export default "__VITE_ASSET__C1rbM7NC__"